import React from "react";

/**
 * @component AccessLogIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <AccessLogIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const AccessLogIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="AccessLogIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M8.127 13.646a.5.5 0 01.146.354v3H9.37a.5.5 0 010 1H7.773a.5.5 0 01-.5-.5V14a.5.5 0 01.854-.354z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.42 13.646a.5.5 0 01.353-.146h2a.5.5 0 01.5.5v3.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V14a.5.5 0 01.146-.354zm.853.854V17h1v-2.5h-1z"
      />
      <path d="M14.5 13.5a.5.5 0 00-.5.5v3.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V16a.5.5 0 00-.5-.5H16a.5.5 0 000 1v.5h-1v-2.5h1.5a.5.5 0 000-1h-2z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2h11.03L21 7.075V20a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2zm10.19 2H5v16h14V7.891L15.19 4z"
      />
    </svg>
  )
);
AccessLogIcon.displayName = "AccessLogIcon";
export default AccessLogIcon;
